import type { ChatSessionResponse } from '@onefootprint/request-types/dashboard';

const stash = new Map<string, ChatSessionResponse>();
// A chat's env (live/sandbox), keyed by session id. Per-chat endpoints are
// env-scoped and 404 on the wrong env, so env must resolve synchronously. Pinned
// here so a list refetch can't flip it back to `undefined` and refetch history.
const envStash = new Map<string, boolean>();

export const stashChatSession = (chatSessionId: string, response: ChatSessionResponse, isLive?: boolean) => {
  stash.set(chatSessionId, response);
  if (isLive !== undefined) envStash.set(chatSessionId, isLive);
};

/** Pin a chat's resolved env so subsequent renders read it synchronously. */
export const rememberChatSessionEnv = (chatSessionId: string, isLive: boolean) => {
  envStash.set(chatSessionId, isLive);
};

export const popChatSession = (chatSessionId: string): ChatSessionResponse | undefined => {
  const value = stash.get(chatSessionId);
  if (value) stash.delete(chatSessionId);
  return value;
};

/** Non-destructive read of a just-created chat's env. */
export const peekChatSessionIsLive = (chatSessionId: string): boolean | undefined => {
  return envStash.get(chatSessionId);
};
